/**
 * Alerts the (operator-side) user that an error occurred, and asks them to contact engineering
 *
 * @param {string} doingWhat - What action was in progress when the error occurred
 */
export const thereWasAProblem = (doingWhat: string) => {
  window.alert(`There was a problem ${doingWhat}! Please contact eng.`);
};
